import React, { useEffect, useContext } from "react";
import { Table, Tooltip } from "antd";
import { useSaleSoModel } from "../saleSoModel";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { YhTag } from "@/erp_subpackage/components/YhTag";
import { momentFormat, formatNum } from "@/erp_subpackage/utils/util";
import { MyContext } from "@/store/myContext"
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
import TextPriviewImage from "../TextPriviewImage";
import { invoiceModel } from "../InvoiceModel";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, loading,
        loadData, setSelectedRowKeys, setDescRows
    } = useSaleSoModel();
    const { imageUrl } = invoiceModel();
    const { dispatch, detailsPage } = useContext(MyContext)
    const { getTreeNodeName } = useDictModel(() => []);
    useEffect(() => {
        loadData()
    }, [])
    const onLook = (mode, code) => {
        let tabName = {
            add: "销售单新增",
            edit: "销售单编辑",
            look: "销售单查看",
        }
        let modeKey = "saleSo/" + mode

        //动态传入要删除的nav key
        function handleDispatch(obj = {}) {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.SaleSoDetails({
                    dispatch,
                    modeKey,
                    mode,
                    rowId: code,
                }),
            })
        }
        if (mode === "look") {
            handleDispatch({ deleteKey: modeKey })
        }
    }
    const columns = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '销售单号',
            width: 120,
            fixed: "left",
            dataIndex: 'saleCode',
            render: (text) => <YhTooltip text={text} onClick={() => onLook("look", text)} />,
        }, {
            title: '调拨单号',
            width: 180,
            fixed: "left",
            dataIndex: 'transferOrder',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: '调出单号',
            width: 180,
            fixed: "left",
            dataIndex: 'allocationCode',
            render: (text) => <YhTooltip text={text} />,
        },
        //  {
        //     title: "单据编号",
        //     width: 160,
        //     dataIndex: "orderCode",
        //     render: (text) => <YhTooltip text={text} />,
        // }, 
        {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag status={text} text={getTreeNodeName(text)} />,
        },
        {
            title: '退货状态',
            width: 70,
            dataIndex: 'returnStatus',
            render: (text) => <span>{text=='sale.part-io'? "部分退货":text=='sale.whole-io'? "全部退货":""}</span>,
        },
        {
            title: '支付状态',
            width: 70,
            dataIndex: 'payStatus',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
        },
       
        {
            title: '客户名称',
            width: 150,
            dataIndex: 'customerName',
            render: (text) => <YhTooltip text={text} />,
            // render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        },
        {
            title: '联系人',
            width: 150,
            dataIndex: 'contact',
            render: (text) => <YhTooltip text={text} />,
        },
         {
            title: '联系电话',
            width: 100,
            dataIndex: 'phone',
        }, 
        {
            title: "单据类型",
            width: 100,
            dataIndex: "orderTypeCode",
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
            
        },
       
        {
            title: '销售类型',
            width: 100,
            dataIndex: 'salesTypeName',
            render: (text) => <YhTooltip text={text} />,
        },
         
     
         {
            title: '销售数量',
            width: 80,
            dataIndex: 'totalNum',
        }, {
            title: '销售金额',
            width: 80,
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '优惠金额',
            width: 80,
            dataIndex: 'discountTotalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            // title: '应收金额',
            title: '营业额',
            width: 80,
            dataIndex: 'receivedAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '已收金额',
            width: 80,
            dataIndex: 'receivableAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '销售成本',
            width: 80,
            dataIndex: 'totalCost',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '销售毛利',
            width: 80,
            dataIndex: 'grossProfit',
            render: (text) => `￥${String(text).indexOf('-') > -1 ? "-" : ""}${formatNum(text)}`
        }, {
            title: '退货数量',
            width: 80,
            dataIndex: 'returnTotalNum',
        }, {
            title: '开票状态',
            width: 80,
            dataIndex: 'invoiceStatus',
            //render: (text) => text == 1 ? "已开票" : "未开票"
             render: (text) => <YhTooltip text={text == 1 ? "已开票" : "未开票"} />,
        }, 
        {
            title: "订单来源",
            width: 120,
            dataIndex: "orderSourceName",
            render: (text) => <YhTooltip text={text} />,
        },
        // {
        //     title: '开票类型',
        //     width: 120,
        //     dataIndex: 'invoiceTypeCode',
        //     render: (text) => <p className="one-line">{getTreeNodeName(text)}</p>,
        // }, 
        {
            title: '发票类型',
            width: 160,
            dataIndex: 'invoiceTypeName',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: '发票编号',
            width: 80,
            dataIndex: 'invoiceNum',
            ellipsis: true,
            render: (text, record) => {
                return (
                    <TextPriviewImage text={text} previewList={record.invoiceMd5?.split(",")} imageUrl={imageUrl} />
                )
            },
        },
        {
            title: '车辆类型',
            width: 90,
            dataIndex: 'vehicleTypeName',
            render: (text) => <YhTooltip text={text} />,
        },
         {
            title: '车牌号',
            width: 80,
            dataIndex: 'licensePlate',
            render: (text) => <YhTooltip text={text} />,
            // render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, 
        {
            title: 'VIN码',
            width: 80,
            dataIndex: 'vin',
            render: (text) => <YhTooltip text={text} />,
            //render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, 
        {
            title: '结算方',
            width: 90,
            dataIndex: 'settlementPartyName',
            render: (text) => <YhTooltip text={text} />,
            //render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, 
        {
            title: '结算类型',
            width: 80,
            dataIndex: 'payType',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
            
        },
        // {
        //     title: "付款时间",
        //     width: 160,
        //     dataIndex: 'paytime',
        //     render: (text) => momentFormat(text)
        // },
        {
            title: "支付方式",
            width: 200,
            dataIndex: 'paymentMethodName',
            render: (text,record) => <YhTooltip text={record?.settleDetails[0]?.payMethodName ?? ''} />,
        },
         {
            title: '销售员',
            width: 80,
            dataIndex: 'saleUser',
            render: (text) => <YhTooltip text={text} />,
            //render: (text) => <p className="one-line">{text}</p>,
        }, {
            title: '制单人',
            width: 60,
            dataIndex: 'createUser',
            render: (text) => <YhTooltip text={text} />,
            //render: (text) => <p className="one-line">{text}</p>,
        }, {
            title: '制单时间',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '库管员',
            width: 60,
            dataIndex: 'storekeeper',
            render: (text) => <YhTooltip text={text} />,
            //render: (text) => <p className="one-line">{text}</p>,
        }, {
            title: '出库时间',
            width: 130,
            dataIndex: 'stockIoTime',
            render: (text) => momentFormat(text)
        }, {
            title: '结算员',
            width: 130,
            dataIndex: 'reckoner',
            render: (text) => <p className="one-line">{text}</p>,
        }, {
            title: '结算日期',
            width: 130,
            dataIndex: 'settleTime',
            render: (text) => momentFormat(text)
        },
        //  {
        //     title: '核销时间',
        //     width: 130,
        //     dataIndex: 'writeOffTime',
        //     render: (text) => momentFormat(text)
        // },
        {
            title: '作废原因',
            width: 120,
            dataIndex: 'cancelReason',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, {
            title: '财务备注',
            width: 120,
            dataIndex: 'fmsNote',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, {
            title: "收货人",
            width: 80,
            dataIndex: "consignee",
        }, {
            title: "收货电话",
            width: 120,
            dataIndex: "consigneePhone",
        }, {
            title: "收货地址",
            width: 160,
            dataIndex: "consigneeAddress",
            render: (text) => <YhTooltip text={text} />,
            // render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, 
        {
            title: "所属机构",
            width: 160,
            dataIndex: "shopName",
            render: (text) => <YhTooltip text={text} />,
        },
        {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, {
            title: '打印次数',
            width: 70,
            fixed: "right",
            align: "center",
            dataIndex: 'printingTimes',
        }
    ];
    //点击行选高亮
    const onRow = (record) => {
        let { saleCode } = record
        let findIndexDesc = descRows.findIndex((item) => (item.saleCode === saleCode))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(saleCode);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record) => {
        setDescRows([record])
        setSelectedRowKeys([record.saleCode])
    }
    return (
        <Table
            style={{ cursor: "pointer" }}
            loading={loading}
            rowKey={record => record.saleCode}
            rowSelection={{
                onChange: (selectedRowKeys, selectedRows) => {
                    setSelectedRowKeys(selectedRowKeys);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                // onClick: () => onRow(record.id as string),
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    onRightClick(record)
                }
            })}
            scroll={dataSource.length ? { x: 'max-content', y: "calc(100vh - 430px)" } : { x: 'max-content' }}
        />
    )
}
